
const achievements = [
  {
    icon: 'ri-time-line',
    number: '5+',
    label: 'Years Experience',
    description: 'Crafting exceptional designs',
  },
  {
    icon: 'ri-palette-line',
    number: '100+',
    label: 'Logos &amp; Branding',
    description: 'Successful projects delivered',
  },
  {
    icon: 'ri-instagram-line',
    number: '50+',
    label: 'Social Campaigns',
    description: 'High-impact designs created',
  },
  {
    icon: 'ri-star-line',
    number: '100%',
    label: 'Client Satisfaction',
    description: 'Perfect track record',
  },
];

export default function Experience() {
  return (
    <section id="experience" className="relative py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 font-['Montserrat']">
            Experience &amp; <span className="text-[#fcd34d]">Achievements</span>
          </h2>
          <p className="text-white/60 text-lg font-['Roboto'] max-w-2xl mx-auto">
            A proven track record of excellence and client satisfaction
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {achievements.map((achievement, index) => (
            <div
              key={index}
              className="group relative bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10 hover:border-[#fcd34d]/50 shadow-xl hover:shadow-2xl hover:shadow-[#fcd34d]/20 transition-all duration-500 hover:scale-110 text-center cursor-pointer"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-[#fcd34d]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"></div>
              
              <div className="relative z-10">
                <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-[#fcd34d] to-[#facc15] rounded-2xl mx-auto mb-6 shadow-lg shadow-[#fcd34d]/30 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                  <i className={`${achievement.icon} text-4xl text-[#0f172a]`}></i>
                </div>

                <h3 className="text-5xl font-bold text-[#fcd34d] mb-2 font-['Montserrat'] group-hover:scale-110 transition-transform duration-300">
                  {achievement.number}
                </h3>

                <p className="text-xl font-semibold text-white mb-2 font-['Montserrat']">
                  {achievement.label}
                </p>

                <p className="text-white/60 text-sm font-['Roboto']">
                  {achievement.description}
                </p>
              </div>

              <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-[#fcd34d]/10 to-transparent rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-white/10 shadow-xl">
            <p className="text-white/80 text-lg font-['Roboto'] mb-4">
              <strong className="text-[#fcd34d]">Featured</strong> in exhibitions and online publications
            </p>
            <p className="text-white/60 font-['Roboto']">
              Recognized for outstanding design work and creative excellence
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
